import {
  loginRequest,
  postJsonRequest,
  getRequest
} from "@/utils/api";
import { qiniuPublicGetFile, testUri, uri } from "@/api/uri/base";
import StorageHelp from "@/utils/storageHelp";
import Toast from '@/utils/toast'

const storageHelp = new StorageHelp();

/**
 * 通过七牛key 获取文件
 * @returns false:不存在  true:存在
 */
export function getPublicFileUrlSingle(key) {
  return new Promise((resolve, reject) => {
    getRequest(qiniuPublicGetFile + "?fileKey=" + key).then(resp => {
      if (resp.status === 1) {
        resolve(resp.data);
      }
    });
  });
}

/**
 * 获取系统配置  设置默认3天过期
 * @return {Promise<any>}
 */

export function getPlatformConfig(force = false) {
  let storagePlatformConfig = storageHelp.getPlatformConfig();
  if (storagePlatformConfig !== null && !force) {
    return new Promise((resolve, reject) => {
      resolve(storagePlatformConfig);
    });
  }
  return new Promise((resolve, reject) => {
    getRequest(uri.platformConfig).then(resp => {
      console.log('平台数据', resp)
      let getPlatformConfigMap = {};
      (resp.data || []).forEach(item => {
        getPlatformConfigMap[item.key] = item.value;
      });
      storageHelp.setPlatformConfigStorage(getPlatformConfigMap);
      resolve(getPlatformConfigMap);
    }).catch(err => {
      // Toast.show({
      //   message: err || '获取平台数据失败',
      //   type: 'error'
      // })
      //请求失败读取本地的
      resolve(storagePlatformConfig);
    });
  });

}

/**
 * 通過typeCode 获取字典
 * @param sortColumnName  是否通过名字排序
 * @param sortRule 排序规则 asc desc
 * @return {Promise<any>}
 */

export function getSysDictByTypeCode(typeCode, { sortColumnName, sortRule }) {


  let params = {};
  if (typeCode) {
    params.typeCode = typeCode;
  }
  if (sortColumnName) {
    params.sortColumnName = 1;
  }
  if (sortRule) {
    params.sortRule = sortRule;
  }
  return new Promise((resolve, reject) => {
    getRequest(uri.sysDict.selectByTypeCode, params).then(resp => {
      resolve(resp.data);
    });
  });

}




// WEBPACK FOOTER //
// ./src/api/base/base.js